import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=6a8d5cd0&scoped=true"
import script from "./MoneyInput.vue?vue&type=script&lang=js"
export * from "./MoneyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d5cd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8d5cd0')) {
      api.createRecord('6a8d5cd0', component.options)
    } else {
      api.reload('6a8d5cd0', component.options)
    }
    module.hot.accept("./MoneyInput.vue?vue&type=template&id=6a8d5cd0&scoped=true", function () {
      api.rerender('6a8d5cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/components/MoneyInput.vue"
export default component.exports